const React = require("react");
const Menu = require("@material-ui/core/Menu").default;
const MenuItem = require("@material-ui/core/MenuItem").default;
const noop = require("mn-utils/noop");
const withState = require("../../../../../../../../utils/withState");

const {WALLETS_DATA, WALLET_TYPES} = require('../../../../../../../../constants/wallets');
const {apiAdminWalletList} = require("../../../../../../../../api/admin/wallet");
const map = require("mn-utils/map");
const upperFirst = require("mn-utils/upperFirst");

module.exports = withState((setState, self, onMount) => {
  const {
    TYPE_EXCHANGE,
    TYPE_WALLET,
    TYPE_WALLET_WEB,
    TYPE_APP_PAY,
    TYPE_KLUB,
    TYPE_MANUAL,
  } = WALLET_TYPES;

  onMount(() => {
    setState({
      loading: true,
    });

    apiAdminWalletList().finally((error, response) => {
      const wallets = {
        [TYPE_APP_PAY]: [],
        [TYPE_KLUB]: [],
        [TYPE_WALLET]: [],
        [TYPE_WALLET_WEB]: [],
        [TYPE_EXCHANGE]: [],
        [TYPE_MANUAL]: [],
      };

      const unusedWallets = [];

      (response && response.list || []).forEach((el) => {
        const data = WALLETS_DATA[el.name] || {};

        if (data.type && wallets[data.type]) {
          wallets[data.type].push({
            id: el.name,
            name: data.name || el.name,
          });
        } else {
          unusedWallets.push(el.name);
        }
      });

      console.log('-------unusedWallets', unusedWallets);
      console.log('-------usedWallets', wallets);

      setState({
        // wallets: response && response.list || [],
        wallets,
        loading: false,
      });
    });
  });

  return (state, props) => {
    const {anchorEl, open, onChange = noop, onClose = noop} = props;
    const wallets = state.wallets || {};
    const walletTypes = Object.keys(wallets);

    return (
      <Menu
        id="walletSelectorMenu"
        aria-labelledby="walletSelector"
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >

        <div style={{width: anchorEl && anchorEl.offsetWidth}}>
          {map(walletTypes, (key) => {
            const walletsList = wallets[key] || [];

            if (!walletsList.length) return;

            return (
              <>
                {![TYPE_APP_PAY, TYPE_KLUB].includes(key) && (
                  <div className="pv10 ttU tc c0 bgEEE">
                    {key.split('_').map(upperFirst).join(' ')}
                  </div>
                )}
                {map(walletsList, ({id, name}) => {
                  return (
                    <div key={id} style={{width: anchorEl && anchorEl.offsetWidth}}>
                      <MenuItem
                        className="w"
                        onClick={() => {
                          onChange(id);
                          onClose();
                        }}
                      >
                        {name}
                      </MenuItem>
                    </div>
                  )
                })}
              </>
            );
          })}
        </div>

        {/*{walletsIdsList.map((key) => (*/}
        {/*  <div key={key} style={{width: anchorEl && anchorEl.offsetWidth}}>*/}
        {/*    <MenuItem*/}
        {/*      className="w"*/}
        {/*      onClick={() => {*/}
        {/*        onChange(key);*/}
        {/*        onClose();*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      {WALLETS_DATA[key].name}*/}
        {/*    </MenuItem>*/}
        {/*  </div>*/}
        {/*))}*/}
      </Menu>
    )
  }
})
